var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isFilterChoiceQueryValue, isDateRange, } from '../types/filtersTypes';
import { FIELD_NAMES } from 'src/services/core/types/moConfigTypes';
import { SHORTCUT_DATES } from 'src/ui/components/Input/DateTimeInput/constants';
import { valueExist } from 'src/shared/helpers/objHelpers';
var SEARCH_FIELD_LABEL = 'search';
export var isIncompleteDateRange = function (choiceValue) {
    return choiceValue !== undefined &&
        !Array.isArray(choiceValue) &&
        ((Object.keys(choiceValue).findIndex(function (key) { return key === 'startDate'; }) !== -1 &&
            Object.keys(choiceValue).findIndex(function (key) { return key === 'endDate'; }) === -1) ||
            (Object.keys(choiceValue).findIndex(function (key) { return key === 'startDate'; }) === -1 &&
                Object.keys(choiceValue).findIndex(function (key) { return key === 'endDate'; }) !== -1));
};
/**
 * When a query conf has multiple target fields on the Search API, we must duplicate this conf
 * in order to send multiple 'OR' sub-queries. This method does the initial duplication.
 */
var duplicateQueryConfForEachFieldName = function (queryConf) {
    var choicesByFieldName = extractChoicesByFieldName(queryConf);
    var fieldNames = Object.keys(choicesByFieldName);
    return fieldNames.map(function (fieldName) { return (__assign(__assign({}, queryConf), { fieldName: fieldName, values: choicesByFieldName[fieldName] })); });
};
var extractChoicesByFieldName = function (queryConf) {
    var values = queryConf.values;
    var fieldNames = queryConf.fieldNames || [queryConf.fieldName];
    var outputMap = {};
    fillChoicesByFieldNameFromChoices(outputMap, values, fieldNames);
    return outputMap;
};
var fillChoicesByFieldNameFromChoices = function (outputMap, choices, parentFieldNames) {
    choices.forEach(function (choice) {
        var fieldNames = choice.fieldNames || parentFieldNames;
        fillChoicesByFieldNameFromChoice(outputMap, choice, fieldNames);
    });
};
var fillChoicesByFieldNameFromChoice = function (outputMap, choice, parentFieldNames) {
    var choiceValue = choice.value;
    if (isFilterChoiceQueryValue(choiceValue)) {
        addChoiceForFieldNames(outputMap, choice, parentFieldNames);
    }
    else {
        var subChoices = choiceValue;
        fillChoicesByFieldNameFromChoices(outputMap, subChoices, parentFieldNames);
    }
};
var addChoiceForFieldNames = function (map, choice, fieldNames) {
    fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.forEach(function (fieldName) { return addChoiceForFieldName(map, choice, fieldName); });
};
var addChoiceForFieldName = function (map, choice, fieldName) {
    if (!map[fieldName]) {
        map[fieldName] = [];
    }
    map[fieldName].push(choice);
};
var buildQueryPartForValueItem = function (queryConf, valueItem) {
    var value = (valueItem || {}).value;
    if (!isFilterChoiceQueryValue(value)) {
        return null;
    }
    if (isDateRange(value)) {
        var startDate = value.startDate, endDate = value.endDate, shortcutDate_1 = value.shortcutDate;
        if (valueExist(shortcutDate_1)) {
            var valueByShortcut = SHORTCUT_DATES.find(function (shortcutDateConf) { return shortcutDateConf.type === shortcutDate_1; });
            if (valueByShortcut) {
                return {
                    fieldName: queryConf.fieldName,
                    operator: queryConf.operator,
                    value: valueByShortcut.startDate,
                    value2: valueByShortcut.endDate,
                };
            }
        }
        return {
            fieldName: queryConf.fieldName,
            operator: queryConf.operator,
            value: startDate,
            value2: endDate,
        };
    }
    else if (isIncompleteDateRange(value)) {
        return null;
    }
    else if (typeof value === 'string' || typeof value === 'number') {
        return {
            fieldName: queryConf.fieldName,
            operator: queryConf.operator,
            value: value,
        };
    }
    else {
        return value;
    }
};
/**
 * Build one or more search query object for each given query confs.
 * When a query conf has several values, it will usually generate several search query parts.
 */
var buildQueryParts = function (queryConfs) {
    return queryConfs.flatMap(function (queryConf) {
        return queryConf.values
            .map(function (valueItem) { return buildQueryPartForValueItem(queryConf, valueItem); })
            .filter(function (queryPart) { return !!queryPart; });
    });
};
var convertFilterToQueryPart = function (filter) {
    if (!filter) {
        return null;
    }
    if (filter.fieldName === FIELD_NAMES.SEARCH) {
        var searchValue = filter.values[0].value;
        if (searchValue) {
            return { value: searchValue };
        }
        return null;
    }
    if (filter.fieldName === FIELD_NAMES.PRODUCTS) {
        return null;
    }
    var queryConfs = duplicateQueryConfForEachFieldName(filter);
    var queryParts = buildQueryParts(queryConfs);
    if (queryParts.length > 1) {
        return { OR: queryParts };
    }
    else if (queryParts.length === 1) {
        return queryParts[0];
    }
    else {
        return null;
    }
};
var convertFiltersToSearchQuery = function (selectedFilters) {
    var filtersToConvert = selectedFilters.filter(function (item) {
        var _a;
        if (item.values.length <= 0 || item.fieldName === FIELD_NAMES.PRODUCTS) {
            return false;
        }
        var firstValue = (_a = item.values[0]) === null || _a === void 0 ? void 0 : _a.value;
        if (isDateRange(firstValue)) {
            var startDate = firstValue.startDate, endDate = firstValue.endDate, shortcutDate = firstValue.shortcutDate;
            return (valueExist(startDate) && valueExist(endDate)) || valueExist(shortcutDate);
        }
        return true;
    });
    if (!filtersToConvert) {
        return null;
    }
    var haveNoFilter = filtersToConvert.length === 0;
    var isUniqueFilter = filtersToConvert.length === 1;
    var haveMultipleFilter = filtersToConvert.length > 1;
    if (haveNoFilter) {
        return null;
    }
    if (isUniqueFilter) {
        var uniqueFilter = filtersToConvert[0];
        return convertFilterToQueryPart(uniqueFilter);
    }
    if (haveMultipleFilter) {
        return { AND: filtersToConvert.map(convertFilterToQueryPart).filter(function (flt) { return !!flt; }) };
    }
};
export var convertFiltersToSearchApiRequest = function (filters, userInfo) {
    var _a;
    // fieldName, may not be the best way to do it
    var products = filters.query.find(function (query) { return query.fieldName === FIELD_NAMES.PRODUCTS; });
    var productsValues = products && ((_a = products.values) === null || _a === void 0 ? void 0 : _a.length) ? products === null || products === void 0 ? void 0 : products.values.map(function (product) { return product.value; }) : null;
    try {
        var filtersWithVariables = JSON.parse(JSON.stringify(filters.query).replace(/\$username/g, userInfo.preferred_username));
        return __assign(__assign({}, filters), { query: convertFiltersToSearchQuery(filtersWithVariables), products: productsValues || ['*'] });
    }
    catch (error) {
        console.error("Can't replace variable into filter", error);
    }
};
var isFilterAlreadySelected = function (selectedFilters, filter) {
    return selectedFilters.findIndex(function (selectedFilter) { return selectedFilter.fieldName === filter.fieldName; }) !== -1;
};
export var updateQuerySearch = function (allQueries, allQueriesSelected, queryToUpdate, value) {
    var queryAlreadySelected = allQueriesSelected.findIndex(function (flt) { return flt.fieldName === queryToUpdate.fieldName; }) !== -1;
    if (queryAlreadySelected) {
        return allQueriesSelected.map(function (query) {
            return query.fieldName === queryToUpdate.fieldName ? __assign(__assign({}, query), { values: [{ label: SEARCH_FIELD_LABEL, value: value }] }) : query;
        });
    }
    else {
        return __spreadArray(__spreadArray([], allQueriesSelected, true), [
            {
                id: queryToUpdate.id,
                fieldName: queryToUpdate.fieldName,
                fieldNames: queryToUpdate.fieldNames,
                operator: queryToUpdate.operator,
                values: [{ label: SEARCH_FIELD_LABEL, value: value }],
            },
        ], false);
    }
};
export var updateQuerySelected = function (allFilters, selectedFilters, filterToUpdate, choices) {
    var isAlreadySelected = isFilterAlreadySelected(selectedFilters, filterToUpdate);
    if (isAlreadySelected) {
        return selectedFilters.map(function (filter) { return (filter.id === filterToUpdate.id ? __assign(__assign({}, filter), { values: choices }) : filter); });
    }
    else {
        return __spreadArray(__spreadArray([], selectedFilters, true), [
            {
                id: filterToUpdate.id,
                fieldName: filterToUpdate.fieldName,
                fieldNames: filterToUpdate.fieldNames,
                operator: filterToUpdate.operator,
                values: choices,
            },
        ], false);
    }
};
export var updateQueryDate = function (allQueries, selectedFilters, filterToUpdate, dates) {
    var isAlreadySelected = isFilterAlreadySelected(selectedFilters, filterToUpdate);
    if (isAlreadySelected) {
        return selectedFilters.map(function (query) {
            return query.id === filterToUpdate.id
                ? __assign(__assign({}, query), { values: [
                        __assign(__assign({}, query.values[0]), { value: {
                                shortcutDate: dates.shortcutDate,
                                startDate: dates.startDate,
                                endDate: dates.endDate,
                            } }),
                    ] }) : query;
        });
    }
    else {
        return __spreadArray(__spreadArray([], selectedFilters, true), [
            {
                id: filterToUpdate.id,
                fieldName: filterToUpdate.fieldName,
                fieldNames: filterToUpdate.fieldNames,
                operator: filterToUpdate.operator,
                values: [
                    {
                        label: filterToUpdate.label,
                        value: {
                            shortcutDate: dates.shortcutDate,
                            startDate: dates.startDate,
                            endDate: dates.endDate,
                        },
                    },
                ],
            },
        ], false);
    }
};
